// @flow
import { RESORT_MULTIMEDIA } from 'Client/cms/toolkit/constants';
import { addTranslationKeys } from 'Src/i18n';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { buildProductArgs } from 'Utils/graphql';
import { LINE_PRODUCT_MULTIMEDIA } from 'Utils/request/requestDictionary';

type CMSProps = {
  resortId: string,
  photoTitle: string,
  videoTitle: string,
  video360Title: string,
  socialPicturesTitle: string,
};

export const productMultimediaResolver = {
  name: RESORT_MULTIMEDIA,
  resolve: (
    appContext: AppContext,
    props: CMSProps,
    pageContext: PageContext,
    location: ProductRouterLocation,
  ) => {
    const { resortId } = props;
    const { urlParams } = location;
    const productArgs = buildProductArgs(resortId, urlParams);
    const query = `{
      config {
        common {
          close
          galleries {
            gallery
            productGallery
          }
          next
          photoTitle
          previous
          socialPicturesTitle
          videoTitle
          video360Title
        }
      }
      media(${productArgs}) {
        photos {url}
        videos {url thumbnailUrl}
        videos360 {url thumbnailUrl}
      }
      resort(${productArgs}){
        name
      }
      socialPictures(${productArgs}) {
        userName
        imageSmall
        imageLarge
      }
    }`;
    return graphQLClient
      .runQuery(query, appContext, { requestName: LINE_PRODUCT_MULTIMEDIA, strictErrors: false })
      .then(data => {
        addTranslationKeys(data.config);
        return data;
      })
      .catch(() => ({}));
  },
};
